import { get, map, keyBy } from "lodash"
import { createSelector } from "reselect"
import { getUserDatasets, getDatasetEntitlementsEnabled } from "modules/account-root/selectors"
import { isAllAccessTeam } from "helpers/permissions/teams"
import { getRole } from "helpers/permissions/roles"
import { computeTeamTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

const EMPTY_ARRAY = []

const getAdminDatasets = (state) => get(state, "global.data.adminDatasets.data")
const getRawEntitlements = (_, props) => get(props, "teamDatasetEntitlements.team.datasetEntitlements")
const getTeamAlias = (_, props) => get(props, "teamDatasetEntitlements.team.alias")
export const getTeamId = (_, props) => get(props, "teamDatasetEntitlements.team.id")
export const getTeamRole = (_, props) => get(props, "teamDatasetEntitlements.team.role")

export const getDatasets = createSelector(
  [getAdminDatasets, getRole],
  (adminDatasets, role) => role === "admin" ? adminDatasets : EMPTY_ARRAY,
)

export const getEntitlements = createSelector(
  [getRawEntitlements, getUserDatasets],
  (entitlements, datasets) => {
    const datasetsById = keyBy(datasets, "id")
    return map(entitlements, entitlement => ({ ...entitlement, description: get(datasetsById, [entitlement.id, "description"]) }))
  },
)

const getIsAllAccessTeam = createSelector(
  [getTeamAlias],
  (teamAlias) => isAllAccessTeam(teamAlias),
)

export const getTabs = createSelector(
  [getRoute, getPath, getDatasetEntitlementsEnabled, getRole, getTeamRole, getIsAllAccessTeam],
  computeTeamTabs,
)
